/**
 * @generated SignedSource<<a94a622415ac6299a5332ad1cea1e5c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issues_softwareReleasesVersionDetailIssueList_jiraVersion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"issueCard_softwareReleasesVersionDetailIssueList_jiraVersion">;
  readonly " $fragmentType": "issues_softwareReleasesVersionDetailIssueList_jiraVersion";
};
export type issues_softwareReleasesVersionDetailIssueList_jiraVersion$key = {
  readonly " $data"?: issues_softwareReleasesVersionDetailIssueList_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"issues_softwareReleasesVersionDetailIssueList_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "224ec701c99ed1fc3c24b3cb47926906";

export default node;
